import { FIELD_PATHS, FREQUENCY } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DropdownField } from '../../Fields';

const OPTIONS = [
  { value: FREQUENCY.WEEKLY, label: 'Weekly' },
  { value: FREQUENCY.FORTNIGHTLY, label: 'Fortnightly' },
  { value: FREQUENCY.MONTHLY, label: 'Monthly' },
  { value: FREQUENCY.YEARLY, label: 'Yearly' },
];

interface EmploymentIncomeFrequencyProps extends IncomeEntityIndex {
  isDisabled?: boolean;
  isOptional?: boolean;
  disableFailMessage?: boolean;
}

export const EmploymentIncomeFrequency = (props: EmploymentIncomeFrequencyProps) => {
  const { incomeIndex, ...rest } = props;

  return (
    <DropdownField {...rest} name={FIELD_PATHS.INCOME_FREQUENCY(incomeIndex)} options={OPTIONS} shouldAnchorList />
  );
};
